<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="400px")
    v-card
      v-card-title.pb-0.mb-0.px-5.white.text-center.align-center
        v-row(no-gutters).text-center
          v-col.text-center
            h6.my-4.text-center {{ $t('add_email_address_for') }}
      v-card-text.pa-0
        v-form.px-4(ref="form")
          v-col.py-0.mt-4(cols="12")
            p.mb-3.label.basic600--text.text-uppercase {{ $t('email_address') }}
            v-text-field( solo flat background-color="basic200"    height="40" v-model="form.email" outlined dense label="E-mail address" :rules="rules.email"  )
              template(v-slot:label)
                  .p1.basic600--text {{ $t('enter_email_address') }}
          v-col.py-0.mb-n5.mt-n3(cols="12")
            v-row
              v-col.grow.pr-0(style="margin-right:-2px")
                p.mb-3.label.basic600--text.text-uppercase {{ $t('confirmation_code') }}
                v-text-field(solo flat background-color="basic200"    height="40" v-model="form.code" outlined dense label="Confirmation code" :rules="rules.code" style="border-top-right-radius:0px; border-bottom-right-radius:0px")
                  template(v-slot:label)
                    .p1.basic600--text {{ $t('six_digit_code') }}
              v-col.shrink.pl-0
                p.mb-3.label.white--text.text-uppercase {{ $t('tac') }}
                v-btn.white--text.button-AA-medium.info500(:disabled="codeTimer > 0" @click="requestCode" height=40 depressed style="border-top-left-radius:0px; border-bottom-left-radius:0px;") {{ codeTimer <= 0 ? $t('request') : `Request (${codeTimer})` }}
        v-divider
        v-card-actions
          v-spacer
          v-btn.button-AA-medium(color='grey' :loading="loading" text @click='closeModal')
            | {{ $t('cancel') }}
          v-btn.mr-2.button-AA-medium.white--text(color='info500' :loading="loading" depressed height=32 @click="addEmail")
            | {{ $t('add') }}
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  name: 'AddEmail',
  props: ['showModal'],
  data: () => ({
    loading: false,
    form: {
      email: '',
      code: '',
    },
    codeTimer: 0,
    rules: {
      email: [
        v => !!v || 'E-mail address is required',
        v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid',
      ],
      code: [
        v => !!v || 'Confirmation code is required'
      ],
    }
  }),
  computed: {
    ...mapState('user', ['user']),
    ...mapGetters({
      lang: 'language/getLanguage'
    }),
  },
  watch: {
    showModal (val) {
      this.$emit('update:showModal', val)
      if (val) {
        this.$refs.form.reset()
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    requestCode () {
      if (!this.form.email) {
        this.showMessage(['error', this.$t('error_message.enter_email_first')])
        return
      }
      this.$axios.get(`/users/check_email/?email=${encodeURIComponent(this.form.email)}`)
          .then(resp => {
            if (resp.data.available) {
              this.$axios.post('/users/send_verification_code/', { email: this.form.email, language: this.lang })
                  .then(() => {
                    this.showMessage(['info', this.$t('info_message.confirmation_code_sent_to', { text: this.form.email })])
                    this.codeTimer = 30
                    const timer = setInterval(() => {
                      this.codeTimer--
                      if (this.codeTimer <= 0) {
                        clearInterval(timer)
                      }
                    }, 1000)
                  })
                  .catch(() => {
                    this.showMessage(['error', this.$t('error_message.unable_to_send_confirmation')])
                  })
            } else {
              this.showMessage(['error', `${this.form.email} is already tied to different account`])
            }
          })
          .catch(() => {})
    },
    addEmail () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.loading = true
      this.$axios.patch(`/users/${this.user.id}/`, this.form)
        .then(resp => {
          this.$store.commit('user/setUser', resp.data)
          this.showMessage(['success', this.$t('success_message.email_successfully_updated')])
          this.closeModal()
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.invalid_confirmation_code')])
        })
        .finally(() => {
          this.loading = false
        })
    },
    closeModal () {
      this.$emit('update:showModal', false)
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.v-card--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>

<i18n>
{
  "en": {
    "add_email_address_for": "Add email address for sign in",
    "enter_email_address": "Enter Email Address",
    "request": "Request"
  },
  "id": {
    "add_email_address_for": "Tambah email address untuk Log in",
    "enter_email_address": "Masukkan Email Address",
    "request": "Minta"
  }
}
</i18n>
